import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { mailItem } from '../stores/mailbox'

import MailItem from "./MailItem";
import axiosInstance from "../libs/axiosInstant";
import {useQuery} from "react-query";
import numeral from "numeral";
import PerfectScrollbar from 'perfect-scrollbar';
import {Link, useParams} from "react-router-dom";
import * as $ from "jquery"
import Avatar from "./Avatar";
import useMoveMutation from "../libs/MoveHandler";
import {Tooltip,Dropdown} from "bootstrap";
import Toast from "../libs/Toast";

const Mailbox = () => {
    const {reload, moveId, mailItemOpen, mailID, labels, label, config : {user, compose}} = useSelector((state) => state.mailBox)
    const dispatch = useDispatch()

    const [checkedItems, setCheckedItems] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState(null);
    let { slug, id } = useParams();
    slug = (typeof slug === 'undefined') ? label : slug;

    useEffect(() => {
        //console.log(slug, 'slug')
    }, []);
    useEffect(() => {
        if(!id) {
            dispatch(mailItem({id: 0, open: false}));
            $('body').removeClass('mailcontent-show');
            $('.mailbox').removeClass('open');
        }
    }, [id]);

    const handleItem = (ele, id, msg) => {
        if(msg.isBlocked){
            Toast('error', msg.blockedMsg);
            return;
        }
        dispatch(mailItem({id, open: true}));
        const el = $(ele.target).closest('.mail-item')
        //el.addClass('active').siblings().removeClass('active');
        el.removeClass('unread');

        $('.mailcontent-placeholder').siblings().removeClass('d-none');
        $('.mailcontent-placeholder').addClass('d-none');

        /*$('.mailbox').addClass('open');
        $('.mailcontent').eq(0).removeClass('d-none');*/
        if (window.matchMedia('(max-width: 1199px)').matches) {
            $('body').addClass('mailcontent-show');
        }
    }

    const fetchMessages = async (label, page = 1, search) => {
        const { data } = await axiosInstance.get(`/inbox/messages/${label}?page=${page}&q=${search}`)
        setMeta(data.meta);
        return data;
    }

    const { isLoading, isError, data, refetch } = useQuery(['messages', slug, page, search, reload], () => fetchMessages(slug, page, search))

    const mailItemsRef = useRef(null); // Reference to the scroll container
    useEffect(() => {
        const ms = new PerfectScrollbar(mailItemsRef.current);
        return () => {
            ms.destroy();
        }
    }, []);

    useEffect(() => {
        setPage(1);
        dispatch(mailItem({id: null, open: false}));
        $('body').removeClass('mailcontent-show');
    }, [slug]);


    const [checkAll, setCheckAll] = useState(0);
    const deleteItemsRef = useRef(null);
    const checkAllRef = useRef(null);
    const handleCheckAll = (e) => {
        e.preventDefault();
        checkAllRef.current.classList.toggle('checkall');
        deleteItemsRef.current.classList.toggle('d-none');

        $('#mailGroup .mail-item').toggleClass('selected').find('input').attr('checked', !checkAll);
        setCheckAll(!checkAll)

        setCheckedItems(data.rows.map(r => r.id))
    }

    const { moveHandle } = useMoveMutation();
    const handleDelete = (e) => {
        e.preventDefault();
        moveHandle(null, 'trash', checkedItems, true)
        deleteItemsRef.current.classList.toggle('d-none');
        refetch()
    }

    const [userMenu, setUserMenu] = useState(0)
    useEffect(() => {

        $('.mailbox-menu').on('click', function(e){
            e.preventDefault();
            if (window.matchMedia('(max-width: 767px)').matches) {
                $('body').toggleClass('sidebar-show');
            } else {
                $('body').toggleClass('sidebar-hide');
            }
            //mc.update();
        });

        $('.backdrop').on('click', function(e){
            $('body').removeClass('sidebar-show');
        });

        $('.mail-item [type=checkbox]').on('checked', (e) => {
            handleCheckAll(e)
        })
        $('.mailbox-select').on('mouseenter mouseleave', '.dropdown-check, .dropdown-link', function(e){
            if(e.type === 'mouseenter') {
                $(this).parent().addClass('onhover');
            } else {
                $(this).parent().removeClass('onhover');
            }
        });
        /*$('').on('checked', (e) => {
            handleCheckAll(e)
        })*/

        $('[data-bs-toggle="tooltip"]').each((i, el) => {
            new Tooltip(el);
        })

        /*$('[data-bs-toggle="dropdown"]').each((i, el) => {
            new Dropdown(el);
        })*/

        return () => {
            $('.mailbox-menu').off('click');
            $('.mailbox-select').off('click');
            $('.backdrop').off('click');
        }
    }, []);

    useEffect(() => {
        setCheckedItems([]);
        setCheckAll(0);
        checkAllRef.current.classList.remove('checkall');
        deleteItemsRef.current.classList.add('d-none');
    }, [page]);

    const note = labels?.tabs.find((tab, i) => (tab.slug === slug) || (slug === 'inbox' && i === 0))?.description;

    const handleSearch = (ele) => {
        setPage(1)
        setSearch(ele.target.value)
    };

    useEffect(() => {
        if(data && data.rows) {
            data.rows = data?.rows.filter((m) => m.id !== moveId);
        }
    }, [data, moveId])

    useEffect(() => {
        if(moveId > 0) refetch()
    }, [moveId])

    const handleCheckItem = (ele, msg_id) => {
        setCheckedItems([...checkedItems, msg_id])
        deleteItemsRef.current.classList.remove('d-none');
    }

    useEffect(() => {
        setInterval(() => refetch(), (1000  * 60) * 1)//every 1 Mint
    }, []);

    return (
        <div className={"mailbox " + (mailItemOpen ? 'open' : '') + (search.length > 0 ? ' search-box' : '')}>
            <div className="mailbox-header">
                <a href="/" className="mailbox-menu"><i className="ri-menu-2-fill"></i></a>
                <div className="mailbox-search">
                    <i className="ri-search-line"></i>
                    <input type="search" className="form-control" placeholder="Search message"
                           onChange={(ele) => handleSearch(ele)}/>
                </div>
                <a className="mail-avatar" data-bs-toggle="dropdown" onClick={() => setUserMenu(!userMenu)}>
                    <Avatar row={user}/>
                </a>
                <div className={`dropdown-menu user-drop-menu ${(userMenu ? 'show' : '')}`}>
                    <div className="user-menu">
                        <div className="mail-avatar user-avatar">
                            <Avatar row={user}/>
                        </div>
                        <div>
                            <div><b>{user.display_name}</b></div>
                            <div><small>{user.username}</small></div>
                            <div><small>{user.member_type}</small></div>
                        </div>
                    </div>
                    <hr className="m-1"/>
                    <div className="d-flex justify-content-between">
                        <Link to="/logout" className="btn btn-primary btn-sm ms-2" style={{backgroundColor: compose.bgButton, color: compose.colorButton, borderColor: compose.bgButton}}>
                            <i className="ri-lock-line"/> Logout
                        </Link>
                        <a href={user.profile_url} className="btn btn-secondary btn-sm me-2" target="_blank">
                            <i className="ri-user-3-line"/> Profile
                        </a>
                    </div>
                </div>
            </div>

            <div className="mailbox-option">
                <div className="mailbox-select dropdown">
                    <a className="dropdown-check" ref={checkAllRef} onClick={handleCheckAll} data-bs-toggle="tooltip"
                       title="Check All">
                        <i className="ri-checkbox-blank-line"></i>
                        <i className="ri-checkbox-line"></i>
                        <i className="ri-checkbox-indeterminate-fill"></i>
                    </a>
                    <a className="dropdown-link" data-bs-toggle="dropdown">
                        <i className="ri-arrow-down-s-line"></i>
                    </a>
                    <div className="dropdown-menu">
                        <a href="" className="dropdown-item all active"><i className="ri-check-fill"></i> All</a>
                        <a href="" className="dropdown-item read"><i className="ri-check-line"></i> Read</a>
                        <a href="" className="dropdown-item unread"><i className="ri-check-line"></i> Unread</a>
                    </div>

                    <a className="dropdown-check" onClick={() => refetch()} data-bs-toggle="tooltip" title="Reload"><i className="ri-refresh-line"></i></a>
                    <a className="dropdown-check delete-selected d-none" onClick={handleDelete} ref={deleteItemsRef} data-bs-toggle="tooltip" title="Delete Selected">
                        <i className="ri-delete-bin-2-line"></i>
                    </a>
                </div>
                <div className="ms-auto d-flex align-items-center">
                    <span>{`${numeral(meta?.from).format('0,0')}-${numeral(meta?.to).format('0,0')} of ${numeral(meta?.total).format('0,0')}`}</span>
                    <a onClick={() => setPage(meta?.prev_page)} className="pager prev" data-bs-toggle="tooltip" title="Previous">
                        <i className="ri-arrow-left-s-line"></i>
                    </a>
                    <a onClick={() => setPage(meta?.next_page)} className="pager next" data-bs-toggle="tooltip" title="Next">
                        <i className="ri-arrow-right-s-line"></i>
                    </a>
                </div>
            </div>

            {search.length === 0 && ['', 'inbox', ...labels?.tabs.map((tab) => tab.slug)].includes(slug) &&
                <ul className={"nav -nav-pills mailbox-tabs " + (mailItemOpen ? 'd-none' : '')}>
                    {labels?.tabs?.map((item, i) => (
                        <li className="nav-item" key={i}>
                            <Link to={`/${item.slug}`}
                                  className={`nav-link ${((item.slug === slug) || (slug === 'inbox' && i === 0) ? `active` : '')}`}
                                  style={{borderColor: item.color}}>
                                <i className={`${item?.icon}`} style={{color: item.color}}></i>
                                <span className="tab-label">{item.label}</span>
                                {item?.total > 0 &&
                                    <small className="badge -bg-success ms-2"
                                           style={{backgroundColor: item.color}}>{numeral(item.total).format('0,0')}</small>
                                }
                                <br/><small className="text-black" dangerouslySetInnerHTML={{__html: item.tag_line}}/>
                            </Link>
                        </li>
                    ))}
                </ul>
            }

            {search.length === 0 && note &&
                <div className="alert alert-warning d-flex align-items-center tab-description m-0" role="alert">
                    <i className="ri-error-warning-line ri-2x"></i>
                    <div>{note}</div>
                </div>
            }

            {isLoading &&
                <div className="loading-container">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <strong role="status">Loading...</strong>
                </div>
            }

            {search.length > 0 &&
                <div className="row justify-content-center mb-2">
                    <div className="col-6">
                        <div className="alert alert-info d-flex align-items-center tab-description m-0" role="alert">
                            <i className="ri-search-line ri-2x"></i>
                            <div><b>Search:</b> {search}</div>
                        </div>
                    </div>
                </div>
            }

            {data?.meta?.total === 0 &&
                <div className="row justify-content-center mt-2">
                    <div className="col-6">
                        <div className="alert alert-info d-flex align-items-center tab-description p-2" role="alert">
                            <i className="ri-error-warning-line ri-2x"></i>
                            <div>{data.message}</div>
                        </div>
                    </div>
                </div>
            }

            <ul id="mailGroup" className="mail-group" ref={mailItemsRef}>
                {data?.rows?.map((msg, i) => (
                    <MailItem
                        key={i}
                        avatar={(msg.avatar ? msg.avatar : msg.color?.backgroundColor)}
                        sender={msg.display_name}
                        time={msg.date}
                        subject={msg.subject}
                        text={msg.short_msg}
                        unread={(msg.status === 'Unread' /*msg.id !== mailID*/)}
                        msg={msg}
                        onClick={(ele) => handleItem(ele, msg.id, msg)}
                        onCheck={handleCheckItem}
                    />
                ))}
            </ul>

        </div>
    );
};

export default Mailbox;
